import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const dict = {
  tr: {
    nav_home: "Ana Sayfa",
    nav_portfolio: "Portföy",
    nav_beats: "Beats",
    nav_izbirak: "İz Bırak",
    nav_playlist: "Playlist",
    nav_requests: "İşbirliği ",
    nav_about: "Hakkında",
    nav_contact: "İletişim",

    hero_cta1: "Portföyü Keşfet",
    hero_cta2: "Birlikte çalışalım",
    hero_title1: "Son Projeler",
    hero_title2: "Son Yüklediğim Beatler",

    featured_title: "Neden Zateviss?",
    featured_sound_title: "Ses Kimliği",
    featured_sound_desc: "Karanlık, sinematik ve sert — her beat bir hikaye anlatır.",
    featured_comm_title: "Hızlı İletişim",
    featured_comm_desc: "Brief'ini gönder, 24-48 saat içinde geri dönüş al.",
    featured_mix_title: "Pro Mix Yönlendirme",
    featured_mix_desc: "Mix & master sürecinde profesyonel yönlendirme ve kalite kontrol.",

    selected_title: "En Yeniler",
    selected_cta: "Tümünü Gör",

    playlist_teaser_title: "Prod. by zateviss",
    playlist_teaser_desc: "İçinde bulunduğum ya da prodüktörlüğünü üstlendiğim şarkılar.",
    playlist_teaser_cta: "Playlist'i Dinle",

    portfolio_title: "Portföy",
    portfolio_subtitle: "Prod. by zateviss",
    portfolio_filter_all: "Tümü",
    portfolio_cta: "Proje brief'ini gönder",
    portfolio_no_results: "Bu filtreleme için sonuç bulunamadı.",

    beats_cta: "Beatlerimle ilgileniyorsan, bana ulaşabilirsin.",

    modal_credits: "Credits",
    modal_links: "Bağlantılar",
    modal_description: "Açıklama",

    playlist_title: "Prod. by zateviss",
    playlist_subtitle: "Prodüktörlüğünü üstlendiğim veya yapımında bulunduğum şarkılardan bazıları.",
    playlist_intro: "Karanlık atmosferin sesini keşfet. Bu playlist, Zateviss'in ses kimliğini yansıtan seçilmiş parçalardan oluşuyor.",
    playlist_open: "Spotify'da Aç",

    requests_title: "Ne Yapıyoruz?",
    requests_subtitle: "Bana ne istediğini anlat.",
    requests_tab1: "Proje / Özel Brief",
    requests_tab2: "Mix & Master Talebi",
    requests_step1_title: "Formu Doldur",
    requests_step1_desc: "Projeni detaylı anlat.",
    requests_step2_title: "İnceliyorum",
    requests_step2_desc: "Projeni değerlendiriyorum.",
    requests_step3_title: "Dönüş Yapıyorum",
    requests_step3_desc: "Teklifimi iletiyorum.",
    requests_open_form: "Formu yeni sekmede aç",
    requests_faq_title: "Sık Sorulan Sorular",
    requests_faq1_q: "Projenin teslimi ne kadar sürer?",
    requests_faq1_a: "Sanatçının da müsaitliğine göre mix & mastering ve beat ayrı ayrı ortalama 5 günde, komple bir proje ise 1-2 haftada teslim edilir.",
    requests_faq2_q: "Ücretler neye göre belirleniyor?",
    requests_faq2_a: "Bütün projelerde ücretler projenin tarzına ve gereksinimlerine göre belirleniyor.",
    requests_faq3_q: "Proje süreci nasıl işliyor?",
    requests_faq3_a: "Projeni gönderdikten sonra 1-2 gün içinde dönüş yapıyorum, her şeyi kafamızda oturttuğumuz zaman start veriyoruz. Projeyi her bi aşamada sana gönderiyorum, birlikte dinleyip içimize sinene kadar aklımıza gelen fikirleri deniyoruz ve içimize sindiği şekilde finalliyoruz. (proje finallendikten sonra da değişiklikler yapabiliyoruz.)",
    requests_response_time: "Genellikle 24-48 saat içinde email ile dönüş yaparım.",

    form_name: "Adın/Mahlasın",
    form_name_placeholder: "Adını/Mahlasını gir",
    form_email: "Email",
    form_tel: "Telefon Numarası",
    form_insta: "Instagram",
    form_tel_placeholder: "Telefon numaranı gir",
    form_insta_placeholder: "Instagram kullanıcı adını gir",
    form_email_placeholder: "email@ornek.com",
    form_project_type: "Ne Yapıyoruz?",
    form_select_placeholder: "Seç",
    form_type_beat: "Beat",
    form_type_collab: "İşbirliği (Collab)",
    form_type_mix_mastering: "Mix & Mastering",
    form_type_mix: "Mix",
    form_type_mastering: "Mastering",
    form_type_full: "Full Prodüksiyon (Beat ve Mix & Mastering)",
    form_type_custom: "Özel Proje",
    form_genre: "Tür",
    form_genre_other: "Diğer",
    form_description: "Proje Detayları",
    form_description_placeholder: "Projeni detaylı anlat — ne tarz bir ses, hangi mood, referans sanatçılar...",
    form_references: "Referans Bağlantılar",
    form_references_placeholder: "YouTube, Spotify veya SoundCloud linkleri (opsiyonel)",
    form_budget: "Bütçe",
    form_budget_placeholder: "Opsiyonel",
    form_deadline: "Zaman",
    form_deadline_placeholder: "Opsiyonel — ne zaman hazır olmalı?",
    form_submit: "Brief Gönder",
    form_submitting: "Gönderiliyor...",
    form_error: "Bir hata oluştu. Lütfen tekrar dene.",
    form_success_title: "Gönderildi!",
    form_success_desc: "Brief'in başarıyla gönderildi. En kısa sürede email ile geri dönüş yapacağım.",
    form_track_title: "Parça Adı",
    form_track_placeholder: "Parçanın adını gir",
    form_current_state: "Mevcut Durum",
    form_state_raw: "Ham Kayıt",
    form_state_rough: "Kaba Mix",
    form_state_final: "Tam Mix & Master Gerek",
    form_notes: "Özel Notlar",
    form_notes_placeholder: "Eklemek istediğin notlar (opsiyonel)",
    form_mix_submit: "Talebi Gönder",
    form_send_another: "Yeni Form Gönder",
    form_project_name: "Demo Göndermek İstersen",
    form_project_name_placeholder: "YouTube, Spotify veya SoundCloud linkleri (opsiyonel)",
    about_title: "Hakkında",
    about_bio: "Üretimi, yaratıcılığı ve ilhamı temsil eder. Hayatının her alanında bu kavramlara olan hayranlığı doğrudan müziğine yansır. Ortalama 5 yıllık prodüksiyon tecrübesiyle beat, aranje, mix ve mastering gibi süreçleri iş olarak değil, sanat olarak ele alır.",
    about_palette_title: "Ses Paleti",
    about_links_title: "Bağlantılar",
    about_zateviss_title: "Zateviss",
    about_zateviss_desc: "Üretimi, yaratıcılığı ve ilhamı temsil eder. Hayatının her alanında bu kavramlara olan hayranlığı doğrudan müziğine yansır. Ortalama 5 yıllık prodüksiyon tecrübesiyle beat, aranje, mix ve mastering gibi süreçleri iş olarak değil, sanat olarak ele alır.",
    about_tag_title: "Producer Tag",
    about_tag_desc: "Projelerden sonra 'baba sen insan mısın ya?', 'kanka sen insan değilsin amk' gibi cümleleri sık sık duymaya başladıktan sonra 'not the way a human does' cümlesi Producer Tag'i haline gelmiştir. Bu ifade, standart düşünce kalıplarının dışına çıkan üretim anlayışını ve projelere yaklaşım biçimini temsil eder",
    about_vision_title: "Vizyon",
    about_vision_desc: "Zateviss, bu dünyaya üretmek için gelmiştir. Zamana karşı dayanıklı, tekrar tekrar dinlenen ve insanları etkileyip ilham verebilecek eserler ortaya koymayı hedefler. Her projede öncelik; tekniği kusursuz kullanmak değil, hissi olabildiğince net ve gerçek bir şekilde sunmaktır.",

    contact_title: "İletişim",
    contact_subtitle: "Ulaşman gerekiyorsa.",
    contact_email_label: "Email",
    contact_instagram_label: "Instagram",
    contact_copy: "Kopyala",
    contact_copied: "Kopyalandı!",
    contact_mailto: "Email Gönder",
    contact_response: "Genellikle 24-48 saat içinde email ile dönüş yaparım.",
    contact_social_title: "Sosyal Medya",
    contact_email_desc: "Projeler, işbirlikleri veya diğer konular için bana bu email ile ulaşabilirsin.",
    contact_email_desc_demos: "Demo göndermek istersen bu email'i kullanabilirsin.",

    footer_rights: "Tüm hakları saklıdır.",
    footer_nav: "Navigasyon",
    footer_connect: "Bağlantılar",
    form_submit: "Gönder",
    form_submitting: "Gönderiliyor...",
    form_error: "Bir hata oluştu. Tekrar deneyin.",

    feedback_error: "Bir hata oluştu. Tekrar dene.",

    feedback_project_count: "Birlikte kaç proje tamamladık?",
    feedback_project_1_3: "1-3",
    feedback_project_3_5: "3-5",
    feedback_project_5_plus: "5 veya Daha Fazla",

    feedback_q1: "Bana ulaşmak senin için ne kadar kolaydı?",
    feedback_q2: "İletişimimiz ne derecede tatmin ediciydi?",
    feedback_q3: "Fikirlerine değer verildiğini hissettin mi?",
    feedback_q4: "Proje sürecinde kendini rahat hissettin mi?",
    feedback_q5: "Teslim edilen proje ne derecede içine sindi?",
    feedback_q6: "Teslim edilen proje beklentilerini karşıladı mı?",
    feedback_q7: "Ücretlendirme sence ne kadar yerindeydi?",
    feedback_q8: "Türkiye’deki prodüktörlerle karşılaştırırsan?",
    feedback_q9: "Zateviss’i tavsiye eder misin?",

    feedback_revision: "Revizelere olan yaklaşım nasıldı?",
    feedback_revision_bad: "Geçiştirildi / Yanlış yapıldı",
    feedback_revision_mid: "Kısmen dikkate alındı",
    feedback_revision_good: "Genel olarak dikkate alındı",
    feedback_revision_perfect: "Birlikte deneme yanılma gibiydi",

    feedback_respect: "Projene saygı duyulduğunu hissettin mi?",
    feedback_respect_no: "Kesinlikle hayır",
    feedback_respect_partial: "Bir yere kadar",
    feedback_respect_yes: "Evet",
    feedback_respect_definitely: "Kesinlikle evet",

    feedback_experience: "Zateviss ile çalışmak nasıldı?",
    feedback_work_again: "Bir daha çalışmak ister misin? Neden?",
    feedback_improvements: "Geliştirebileceğimiz konular?",
    feedback_extra: "Eklemek istediğin bir şey?",
    feedback_name: "İsmin",
    feedback_instagram: "Instagram",

    producer_years: "Kaç yıldır prodüktörlük yapıyorsun?",
    producer_professional: "Kendini profesyonel olarak tanımlar mısın?",
    producer_genres: "Ağırlıklı olarak hangi tarzları yaparsın?",
    producer_sound: "Kendi sound'un var mı? Nasıl tanımlarsın?",
    producer_specialty: "Tek bir alanda mı uzmansın?",
    producer_specialty_beat: "Sadece Beat",
    producer_specialty_mix: "Sadece Mix & Master",
    producer_specialty_both: "Her ikisi",

    producer_artist_count: "Kaç sanatçı ile çalıştın?",
    producer_bad_experience: "Memnun kalmayan sanatçılar oldu mu? Neden?",
    producer_workflow: "Sanatçılara yaklaşımın ve proje yönetimin?",
    producer_fullname: "İsim Soyisim",
    producer_socials: "Sosyal Medya Hesapların",
    producer_reference: "Referans Proje Linki (Drive / YouTube / Spotify)",
    producer_submit: "Başvuruyu Gönder",
    producer_error: "Başvuru gönderilemedi. Tekrar dene.",

    yes: "Evet",
    no: "Hayır",
    partial: "Kısmen",

    beats_subtitle: "Boşta olan beatler",

    request_project: "Projeler",

    izbirak_title: "İz Bırakanlar",

    wall_invite_mobile_warning: "İmza bırakmak için masaüstü kullan 👊",
    wall_invite_mobile_warning_2: "Cihazının çözünürlüğü çizim yapmayı desteklemiyor.",
    wall_invite_loading: "Kontrol ediliyor...",
    wall_invite_invalid_link: "Link geçersiz.",
    wall_invite_png_url_placeholder: "PNG URL (opsiyonel)",
    wall_invite_artist_name_placeholder: "Sanatçı Adı",
    wall_invite_pen_tool: "Kalem",
    wall_invite_eraser_tool: "Silgi",
    wall_invite_clear_tool: "Temizle",
    wall_invite_submit_button: "Gönder",
    wall_invite_draw_or_upload: "Çiz veya PNG ekle",
    wall_invite_title: "İmzanı Bırak",
    wall_invite_artist_name_required: "İsim lazım kanka",
    wall_invite_export_failed: "İmza atmadın",
    wall_invite_submitted: "Gönderildi 👊",
    wall_invite_color_label: "Renk",
    wall_invite_brush_size_label: "Fırça Kalınlığı",
  },
  en: {
    nav_home: "Home",
    nav_portfolio: "Portfolio",
    nav_beats: "Beats",
    nav_izbirak: "Leave a mark",
    nav_playlist: "Playlist",
    nav_requests: "Collabs",
    nav_about: "About",
    nav_contact: "Contact",

    hero_cta1: "Explore Portfolio",
    hero_cta2: "Let's Work Together",
    hero_title1: "Latest Projects",
    hero_title2: "Latest Beats",

    featured_title: "Why Zateviss?",
    featured_sound_title: "Sound Identity",
    featured_sound_desc: "Dark, cinematic and hard-hitting — every beat tells a story.",
    featured_comm_title: "Fast Communication",
    featured_comm_desc: "Send your brief, get a reply within 24-48 hours.",
    featured_mix_title: "Pro Mix Direction",
    featured_mix_desc: "Professional guidance and quality control through the mix & master process.",

    selected_title: "Latest Works",
    selected_cta: "View All",

    playlist_teaser_title: "Prod. by zateviss",
    playlist_teaser_desc: "Songs I'm involved in or have produced.",
    playlist_teaser_cta: "Listen Now",

    portfolio_title: "Portfolio",
    portfolio_subtitle: "Prod. by zateviss",
    portfolio_filter_all: "All",
    portfolio_cta: "Submit your project brief",
    portfolio_no_results: "No results found for this filter.",

    beats_cta: "If you're interested in my beats, feel free to reach out.",

    modal_credits: "Credits",
    modal_links: "Links",
    modal_description: "Description",

    playlist_title: "Prod. by zateviss",
    playlist_subtitle: "Some of the songs I've produced or been involved in.",
    playlist_intro: "Discover the sound of dark atmosphere. This playlist features curated tracks reflecting the Zateviss sound identity.",
    playlist_open: "Open in Spotify",

    requests_title: "What Are We Doing?",
    requests_subtitle: "Tell me what you need.",
    requests_tab1: "Project / Custom Brief",
    requests_tab2: "Mix & Master Request",
    requests_step1_title: "Fill the Form",
    requests_step1_desc: "Describe your project in detail.",
    requests_step2_title: "I Review",
    requests_step2_desc: "I evaluate your project.",
    requests_step3_title: "Reply by Email",
    requests_step3_desc: "I send my proposal.",
    requests_open_form: "Open form in new tab",
    requests_faq_title: "Frequently Asked Questions",
    requests_faq1_q: "How long does project delivery take?",
    requests_faq1_a: "Depending on the artist's availability, separate beat and mix & master projects are typically delivered within an average of 5 days, while a complete project is delivered within 1-2 weeks.",
    requests_faq2_q: "How does pricing work?",
    requests_faq2_a: "Pricing is determined based on the style and requirements of each project.",
    requests_faq3_q: "How does the project process work?",
    requests_faq3_a: "After you submit your project, I usually reply within 1-2 days. Once we have everything clear, we start the project. I send you updates at every stage, and we listen together, trying out ideas until we're both satisfied and finalize it that way. (Even after the project is finalized, we can make changes.)",
    requests_response_time: "I usually respond within 24-48 hours via email.",

    form_name: "Your Name/Artist Name",
    form_name_placeholder: "Enter your name/artist name",
    form_email: "Email",
    form_tel: "Phone Number",
    form_insta: "Instagram",
    form_tel_placeholder: "Enter your phone number",
    form_insta_placeholder: "Enter your Instagram username",
    form_email_placeholder: "email@example.com",
    form_project_type: "What are we doing?",
    form_select_placeholder: "Choose",
    form_type_beat: "Beat",
    form_type_collab: "Collaboration",
    form_type_mix_mastering: "Mix & Mastering",
    form_type_mix: "Mix",
    form_type_mastering: "Mastering",
    form_type_full: "Full Production (Beat and Mix & Mastering)",
    form_type_custom: "Custom Project",
    form_genre: "Genre",
    form_genre_other: "Other",
    form_description: "Project Details",
    form_description_placeholder: "Describe your project — what kind of sound, mood, reference artists...",
    form_references: "Reference Links",
    form_references_placeholder: "YouTube, Spotify, or SoundCloud links (optional)",
    form_budget: "Budget",
    form_budget_placeholder: "Optional",
    form_deadline: "Timeline",
    form_deadline_placeholder: "Optional — when do you need it?",
    form_submit: "Submit Brief",
    form_submitting: "Submitting...",
    form_error: "Something went wrong. Please try again.",
    form_success_title: "Submitted!",
    form_success_desc: "Your brief has been sent successfully. I'll get back to you via email soon.",
    form_track_title: "Track Title",
    form_track_placeholder: "Enter the track title",
    form_current_state: "Current State",
    form_state_raw: "Raw Recording",
    form_state_rough: "Rough Mix",
    form_state_final: "Needs Full Mix & Master",
    form_notes: "Special Notes",
    form_notes_placeholder: "Any special notes you want to add (optional)",
    form_mix_submit: "Submit Request",
    form_send_another: "Send Another",
    form_project_name: "If You Want to Send a Demo",
    form_project_name_placeholder: "YouTube, Spotify, or SoundCloud links (optional)",

    about_title: "About",
    about_bio: "Zateviss is a Trap/Drill producer known for dark and cinematic sound design. With hard-hitting beats, atmospheric melodies, and modern production techniques, he offers artists a unique sound identity. He pays attention to detail in every project and aims to reflect the artist's vision at the highest level.",
    about_palette_title: "Sound Palette",
    about_links_title: "Links",

    about_zateviss_title: "Zateviss",
    about_zateviss_desc: "Zateviss represents production, creativity, and inspiration. His admiration for these concepts is directly reflected in his music across all areas of his life. With an average of 5 years of production experience, he approaches processes like beat-making, arranging, mixing, and mastering not as a job but as an art form.",
    about_tag_title: "Producer Tag",
    about_tag_desc: "After frequently hearing phrases like 'bro are you even human?' and 'dude you're not human at all' after projects, the phrase 'not the way a human does' has become his producer tag. This expression represents an approach to production and projects that goes beyond standard thinking patterns.",
    about_vision_title: "Vision",
    about_vision_desc: "Zateviss is here to produce. He aims to create timeless works that can be listened to repeatedly and can affect and inspire people. The priority in every project is not to use technique flawlessly, but to present the feeling as clearly and genuinely as possible.",

    contact_title: "Contact",
    contact_subtitle: "If you need to reach out.",
    contact_email_label: "Email",
    contact_instagram_label: "Instagram",
    contact_copy: "Copy",
    contact_copied: "Copied!",
    contact_mailto: "Send Email",
    contact_response: "I usually respond within 24-48 hours.",
    contact_social_title: "Social Media",
    contact_email_desc: "You can reach me at this email for projects, collaborations, or other inquiries.",
    contact_email_desc_demos: "If you want to send a demo, you can use this email.",

    footer_rights: "All rights reserved.",
    footer_nav: "Navigation",
    footer_connect: "Connect",
    form_submit: "Submit",
    form_submitting: "Submitting...",
    form_error: "An error occurred. Please try again.",

    feedback_error: "An error occurred. Please try again.",

    feedback_project_count: "How many projects have we completed together?",
    feedback_project_1_3: "1-3",
    feedback_project_3_5: "3-5",
    feedback_project_5_plus: "5 or More",

    feedback_q1: "How easy was it to reach me?",
    feedback_q2: "How satisfied were you with our communication?",
    feedback_q3: "Did you feel your ideas were valued?",
    feedback_q4: "Did you feel comfortable during the project process?",
    feedback_q5: "How satisfied were you with the delivered project?",
    feedback_q6: "Did the final project meet your expectations?",
    feedback_q7: "How fair was the pricing?",
    feedback_q8: "Compared to other producers in Turkey?",
    feedback_q9: "Would you recommend Zateviss?",

    feedback_revision: "How was the revision process handled?",
    feedback_revision_bad: "Ignored / Done poorly",
    feedback_revision_mid: "Partially considered",
    feedback_revision_good: "Generally considered",
    feedback_revision_perfect: "Collaborative trial & error",

    feedback_respect: "Did you feel your project was respected?",
    feedback_respect_no: "Definitely no",
    feedback_respect_partial: "To some extent",
    feedback_respect_yes: "Yes",
    feedback_respect_definitely: "Absolutely yes",

    feedback_experience: "How was working with Zateviss?",
    feedback_work_again: "Would you like to work together again? Why?",
    feedback_improvements: "Areas we can improve?",
    feedback_extra: "Anything else you’d like to add?",
    feedback_name: "Your Name",
    feedback_instagram: "Instagram",

    producer_years: "How many years have you been producing?",
    producer_professional: "Do you consider yourself professional?",
    producer_genres: "Which genres do you mainly produce?",
    producer_sound: "Do you have your own sound? Describe it.",
    producer_specialty: "Do you specialize in one area?",
    producer_specialty_beat: "Beat Only",
    producer_specialty_mix: "Mix & Master Only",
    producer_specialty_both: "Both",

    producer_artist_count: "How many artists have you worked with?",
    producer_bad_experience: "Have you had dissatisfied artists? Why?",
    producer_workflow: "Your artist approach & workflow?",
    producer_fullname: "Full Name",
    producer_socials: "Social Media Accounts",
    producer_reference: "Reference Project Link (Drive / YouTube / Spotify)",
    producer_submit: "Submit Application",
    producer_error: "Application could not be submitted. Try again.",

    yes: "Yes",
    no: "No",
    partial: "Partially",

    beats_subtitle: "Beats that are up for grabs",

    request_project: "Projects",

    izbirak_title: "Leave a Mark",

    wall_invite_mobile_warning: "Use desktop to leave your mark 👊",
    wall_invite_mobile_warning_2: "Your device's resolution doesn't support drawing.",
    wall_invite_loading: "Checking...",
    wall_invite_invalid_link: "Invalid link.",
    wall_invite_png_url_placeholder: "PNG URL (optional)",
    wall_invite_artist_name_placeholder: "Artist Name",
    wall_invite_pen_tool: "Pen",
    wall_invite_eraser_tool: "Eraser",
    wall_invite_clear_tool: "Clear",
    wall_invite_submit_button: "Submit",
    wall_invite_draw_or_upload: "Draw or upload a PNG",
    wall_invite_title: "Leave Your Mark",
    wall_invite_artist_name_required: "Artist name is required",
    wall_invite_export_failed: "Signature export failed",
    wall_invite_submitted: "Submitted 👊",
    wall_invite_color_label: "Color",
    wall_invite_brush_size_label: "Brush Size",
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('zateviss-lang');
    if (saved) return saved;
    return navigator.language?.startsWith('en') ? 'en' : 'tr';
  });

  useEffect(() => {
    localStorage.setItem('zateviss-lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => {
    return dict[lang]?.[key] || dict['tr']?.[key] || key;
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(l => l === 'tr' ? 'en' : 'tr');
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
